export const APP_VERSION = '3.1.0';

export const ENABLE_REDUX_DEV_TOOLS = true;

export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK'
};

export const COLORS = {
  RED: '#FF634D',
  CYAN: '#4BD5FE',
  WHITE: '#FFFFFF',
  GREY: '#A4A4A4',
  BLUE: '#178DC7',
  INDIGO: '#3F51B5',
  AMBER: '#F1C40F',
  GREEN: '#24B800',
  ORANGE: '#f45100',
  WEEK53: '#8E44AD'
};

export const TABLEAU10 = [
  '#4E79A7',
  '#F28E2B',
  '#E15759',
  '#76B7B2',
  '#59A14F',
  '#EDC948',
  '#B07AA1',
  '#FF9DA7',
  '#9C755F',
  '#BAB0AC'
];
